<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-12 text-right">
							<a-button class="btn btn-info" icon="plus" @click="onAddRecord">{{ $t('general.add') }}</a-button>
							<a-button class="btn btn-success ml5" icon="reload" @click="onReload" />
						</div>
					</div>
					<div class="row pt15">
						<div class="col-md-12">
							<a-input allowClear v-model="searchText" @change="onSearch" placeholder="Búsqueda en clientes..." />
						</div>
						<div class="col-md-12 pt10">
							<a-table :columns="columns" :dataSource="searchText == '' ? customersList : customersListFiltered" :pagination="{ pageSize: 25 }">
								<div slot="nationality" slot-scope="record">
									{{ record.nationality == 'foreign' ? 'Extranjero' : 'Nacional' }}
								</div>
								<div slot="phones" slot-scope="record">
									{{ record.phone }}
								</div>
								<div slot="action" slot-scope="record">
									<a-button class="ml5" type="info" size="small" icon="edit" @click="onEditRecord(record.id)" />
									<a-button class="ml5" size="small" :icon="record.active ? 'minus-circle' : 'plus-circle'" @click="toggleRecord(record.id)" />
								</div>
							</a-table>
						</div>
					</div>
				</div>
			</div>
		</a-spin>
	</div>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'

export default {
	name: 'customersView',
	data() {
		return {
			searchText: '',
			customersListFiltered: [],
		}
	},
	computed: {
		...mapGetters('customers', ['customersList', 'spinnerLoader', 'spinnerLoaderLabel']),
		columns() {
			let columns = [
				{
					title: this.$t('suppliersModule.tableHeaders.id'),
					dataIndex: 'id',
					align: 'center',
				},
				{
					title: 'Nombre del cliente',
					dataIndex: 'full_name',
					key: 'full_name',
				},
				{
					title: 'Tipo de cliente',
					scopedSlots: { customRender: 'nationality' },
				},
				{
					title: this.$t('suppliersModule.tableHeaders.email'),
					dataIndex: 'email',
					key: 'email',
				},
				{
					title: this.$t('suppliersModule.tableHeaders.phones'),
					scopedSlots: { customRender: 'phones' },
				},
				{
					title: this.$t('general.actions'),
					scopedSlots: { customRender: 'action' },
					align: 'right',
					width: '10%',
				},
			]
			return columns
		},
	},
	mounted() {
		this.initModule()
	},
	methods: {
		initModule() {
			let payload = {}
			this.$store.dispatch('customers/GET', payload)
		},
		onReload() {
			this.initModule()
		},
		onAddRecord() {
			this.$router.push('/customers/new')
		},
		onEditRecord(id) {
			this.$store.dispatch('customers/GET_ONE', id)
		},
		toggleRecord(id) {
			Swal.fire({
				title: this.$t('general.deleteMessage.title'),
				html: this.$t('general.deleteMessage.message'),
				icon: 'warning',
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: this.$t('general.yesContinue'),
				cancelButtonText: this.$t('general.cancel'),
			}).then((result) => {
				if (result.isConfirmed) {
					this.$store.dispatch('customers/TOGGLE', {
						section: 'customers',
						id,
					})
				}
			})
		},
		onSearch(event) {
			let { value } = event.target
			this.customersListFiltered = []
			if (value != '') {
				this.customersListFiltered = this.customersList.filter((obj) =>
					Object.values(obj).some((val) => {
						if (typeof val == 'string' && val.toLowerCase().includes(value.toLowerCase())) {
							return true
						}
					}),
				)
			}
		},
	},
}
</script>